/* tslint:disable */
/* eslint-disable */
/**
 * Workflow service API
 * Service for workflow management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ProposedUserDto } from './ProposedUserDto';
import {
    ProposedUserDtoFromJSON,
    ProposedUserDtoFromJSONTyped,
    ProposedUserDtoToJSON,
} from './ProposedUserDto';

/**
 * 
 * @export
 * @interface DarProposalRequestDto
 */
export interface DarProposalRequestDto {
    /**
     * Created or processed Workflow instance Id
     * @type {string}
     * @memberof DarProposalRequestDto
     */
    workflowInstanceId: string;
    /**
     * Organization Id for whose benefit the workflow is performed or the user works
     * @type {string}
     * @memberof DarProposalRequestDto
     */
    orgId?: string;
    /**
     * True if workflow requester proposes themself as DAR. If false, "proposedDAR" should be set
     * @type {boolean}
     * @memberof DarProposalRequestDto
     */
    isRequesterDAR?: boolean;
    /**
     * 
     * @type {ProposedUserDto}
     * @memberof DarProposalRequestDto
     */
    proposedDAR?: ProposedUserDto;
}

/**
 * Check if a given object implements the DarProposalRequestDto interface.
 */
export function instanceOfDarProposalRequestDto(value: object): boolean {
    if (!('workflowInstanceId' in value)) return false;
    return true;
}

export function DarProposalRequestDtoFromJSON(json: any): DarProposalRequestDto {
    return DarProposalRequestDtoFromJSONTyped(json, false);
}

export function DarProposalRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): DarProposalRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'workflowInstanceId': json['workflowInstanceId'],
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'isRequesterDAR': json['isRequesterDAR'] == null ? undefined : json['isRequesterDAR'],
        'proposedDAR': json['proposedDAR'] == null ? undefined : ProposedUserDtoFromJSON(json['proposedDAR']),
    };
}

export function DarProposalRequestDtoToJSON(value?: DarProposalRequestDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'workflowInstanceId': value['workflowInstanceId'],
        'orgId': value['orgId'],
        'isRequesterDAR': value['isRequesterDAR'],
        'proposedDAR': ProposedUserDtoToJSON(value['proposedDAR']),
    };
}

